import { AlertCircle, CheckCircle } from "lucide-react";
import { useState } from "react";
import SectionCard from "./AccounSettingSectionCard";
import PasswordField from "./PasswordField";
import Button from "../common/Button";

const SecuritySettings = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({ message: "", type: "" });
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const showNotification = (message, type) => {
    setNotification({ message, type });
    setTimeout(() => setNotification({ message: "", type: "" }), 4000);
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      showNotification("New passwords do not match.", "error");
      return;
    }
    setIsLoading(true);
    try {
      await authService.changePassword({
        current_password: currentPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });
      showNotification("Password changed successfully!", "success");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      const errorMessage =
        error.response?.data?.current_password?.[0] ||
        "Failed to change password. Please check your current password.";
      showNotification(errorMessage, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {notification.message && (
        <div
          className={`p-4 mb-2 rounded-lg border flex items-center ${
            notification.type === "success"
              ? "bg-green-50 border-green-200 text-green-800"
              : "bg-red-50 border-red-200 text-red-800"
          }`}
        >
          {notification.type === "success" ? (
            <CheckCircle className="w-5 h-5 mr-3" />
          ) : (
            <AlertCircle className="w-5 h-5 mr-3" />
          )}
          {notification.message}
        </div>
      )}
      <SectionCard title="Change Password">
        <form onSubmit={handlePasswordChange} className="space-y-4 max-w-md sentry-mask">
          <PasswordField
            label="Current Password"
            value={currentPassword}
            onChange={setCurrentPassword}
            show={showCurrent}
            onToggle={setShowCurrent}
          />
          <PasswordField
            label="New Password"
            value={newPassword}
            onChange={setNewPassword}
            show={showNew}
            onToggle={setShowNew}
          />
          <PasswordField
            label="Confirm New Password"
            value={confirmPassword}
            onChange={setConfirmPassword}
            show={showConfirm}
            onToggle={setShowConfirm}
          />
          <div className="pt-2">
            <Button type="submit" loading={isLoading} loadingText="Updating...">
              Update Password
            </Button>
          </div>
        </form>
      </SectionCard>
      <SectionCard title="Two-Factor Authentication">
        <div className="flex justify-between items-center">
          <p className="text-secondary-600 text-sm max-w-md">
            Add an extra layer of security to your account. This feature is
            coming soon.
          </p>
          <div className="w-12 h-6 flex items-center bg-gray-300 rounded-full p-1 duration-300 ease-in-out cursor-not-allowed">
            <div className="bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out"></div>
          </div>
        </div>
      </SectionCard>
    </div>
  );
};

export default SecuritySettings;